export const comments_5129825 = {"data":{"data":[],"links":{}}}